var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"idr"},[_c('b-form-input',{attrs:{"type":"text","disabled":_vm.valuedisable == true ? true:false},on:{"keypress":_vm.onlyNumber,"input":_vm.handleInput},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }